import {
  MSSMemberStatus,
  CurrentPayPlan,
  MembershipProductType,
  RoleType,
} from '@ace-clublabs/common-membership-api-types';
import { GetConfirmation, IGetConfirmationRequest } from '../contracts';
import {
  CallbackCardCodeEnum,
  CallbackPaymentMethod,
  IGetConfirmationResponse,
  MSSProductStatus,
  MembershipLevel,
} from '@lib/types';

export const GetConfirmationStub: GetConfirmation = async (request: IGetConfirmationRequest) => {
  return Promise.resolve({
    status: 'success',
    data: {
      members: [
        {
          roleType: RoleType.PRIMARY,
          firstName: 'GRACE',
          lastName: 'PRIMARY',
          status: MSSMemberStatus.EXISTING,
          customerId: 'some-customer-id',
          emailAddress: 'aaa@aaa.com',
          emailStatusCode: '1',
        },
      ],
      email: 'aaa@aaa.com',
      isEmailValid: true,
      loggedInCustomerId: 'some-customer-id',
      effectiveDate: `09/06/2024`,
      confirmationId: 'some-customer-id0906202404073500A',
      products: [
        {
          status: MSSProductStatus.ADDED,
          type: MembershipProductType.RV,
        },
      ],
      currentBillPlan: CurrentPayPlan.ONETIME,
      updatedBillPlan: CurrentPayPlan.RECURRINGELECTRONICCHECK,
      currentBenefitLevel: MembershipLevel.CLASSIC,
      updatedBenefitLevel: MembershipLevel.CLASSIC,
      amount: 35,
      tags: {},
      paymentDetails: {
        paymentType: CallbackPaymentMethod.Echeck,
        last4: '5678',
        expDate: '',
        cardType: null,
        autoPaySuccessful: true,
        isAutoPayRequested: true,
      },
    },
  });
};

export const GetConfirmationErrorStub: GetConfirmation = async (request: IGetConfirmationRequest) => {
  return Promise.reject({
    error: {
      message: 'Unable to process the request',
    },
  });
};

export const mockConfirmationData: IGetConfirmationResponse = {
  members: [
    {
      roleType: RoleType.PRIMARY,
      firstName: 'GRACE',
      lastName: 'SMITH',
      status: MSSMemberStatus.EXISTING,
      customerId: 'some-customer-id',
      emailAddress: 'aaa@aaa.com',
      emailStatusCode: '1',
    },
    {
      roleType: RoleType.ADULT_ASSOCIATE,
      firstName: 'Janet',
      lastName: 'SMITH',
      status: MSSMemberStatus.ADDED,
      customerId: 'some-customer-id',
      emailAddress: 'aaa@aaa.com',
      emailStatusCode: '1',
    },
    {
      roleType: RoleType.DEPENDENT,
      firstName: 'JOHN',
      lastName: 'SMITH',
      status: MSSMemberStatus.ADDED,
      customerId: 'some-customer-id',
      emailAddress: 'aaa@aaa.com',
      emailStatusCode: '1',
    },
  ],
  email: 'aaa@aaa.com',
  isEmailValid: true,
  loggedInCustomerId: 'some-customer-id',
  effectiveDate: `09/06/2024`,
  benefitLevelEffectiveDate: `09/07/2024`,
  confirmationId: 'some-customer-id0906202404073500A',
  products: [
    {
      status: MSSProductStatus.ADDED,
      type: MembershipProductType.RV,
      effectiveDate: '09/03/2024',
    },
  ],
  currentBillPlan: CurrentPayPlan.ONETIME,
  updatedBillPlan: CurrentPayPlan.ONETIME,
  currentBenefitLevel: MembershipLevel.CLASSIC,
  updatedBenefitLevel: MembershipLevel.PLUS,
  amount: 35,
  tags: {},
  paymentDetails: {
    paymentType: CallbackPaymentMethod.CreditCard,
    last4: '5678',
    expDate: '',
    cardType: CallbackCardCodeEnum.VISA,
    isAutoPayRequested: true,
    autoPaySuccessful: true,
  },
};
